'use client';
import React, { useEffect } from 'react';
import { Button, Card, CardTitle, Checkbox, Grid, Label } from '@develos/next-components';
import { useInfoMessages, useTranslations } from '@develos/next-library';
import { MetricLocalizationsFilter } from '@/components';
import { storeSelectors, usePropertyUpdate } from '@/store';
import {
  setActiveRecord,
  setAutoUpdateVehicleDetails,
  setMetricPointPlatformsUIds,
  setVehiclesList,
} from '@/store/liveView';
import { useDispatch, useSelector } from 'react-redux';
import { getButtonTextForHubConnection, getButtonVariantForHubConnection } from './utils';
import useSignalR from '@/features/LiveVehiclesRecords/hooks/useSignalR';

const ControlsSection = () => {
  const { translate } = useTranslations();
  const { error } = useInfoMessages();
  const dispatch = useDispatch();
  const currentLocalization = useSelector(storeSelectors.selectCurrentMetricLocalization);
  const { isConnected, isConnecting, toggleConnection } = useSignalR();

  const { propertyValue: isAutoUpdateEnabled, updateStoreProp: setAutoUpdate } = usePropertyUpdate(
    setAutoUpdateVehicleDetails,
    storeSelectors.selectIsVehicleAutoUpdated,
  );
  const { propertyValue: metricPointPlatformsUIds, updateStoreProp: setMetricPointPlatforms } = usePropertyUpdate(
    setMetricPointPlatformsUIds,
    storeSelectors.selectMetricPointPlatformsUIds,
  );

  const handleOnToggleConnection = async () => {
    await toggleConnection({ metricPointPlatformsUIds }).catch();
  };

  useEffect(() => {
    if (isConnected) {
      toggleConnection({ metricPointPlatformsUIds }).catch();
      error('Z uwagi na zmianę lokalizacji, połączenie na żywo zostało zamkniętę.');
    }

    dispatch(setVehiclesList([]));
    setMetricPointPlatforms([]);
    dispatch(setActiveRecord(undefined));
  }, [currentLocalization]);

  useEffect(() => {
    if (isConnected) {
      toggleConnection({ metricPointPlatformsUIds }).catch();
      error('Z uwagi na zmianę punktów preselekcyjnych, połączenie na żywo zostało zamkniętę.');
    }
  }, [metricPointPlatformsUIds]);

  useEffect(() => {
     return () => {
        if (isConnected) {
          toggleConnection({ metricPointPlatformsUIds }).catch();
        }
      };
  },[])

  return (
    <Card>
      <Card.Body>
        <CardTitle title={translate('Podgląd przejazdów')} />
        <Grid columns={1} mdColumns={12} gap={5}>
          <div className="rm-relative md:rm-col-span-6">
            <MetricLocalizationsFilter
              value={metricPointPlatformsUIds}
              handleChange={(e, values) => setMetricPointPlatforms(values??[])}
            />
          </div>
          <div className="rm-relative md:rm-col-span-6 rm-gap-2 rm-flex rm-flex-col">
            <Label>Automatyczne szczegóły nowego przejazdu</Label>
            <Checkbox name="autoUpdate" checked={isAutoUpdateEnabled} onChange={(isSelected: boolean) => setAutoUpdate(isSelected)} />
          </div>
        </Grid>
      </Card.Body>
      <Card.Footer>
        <Button
          handleClick={handleOnToggleConnection}
          variant={getButtonVariantForHubConnection(isConnected, isConnecting)}
          disabled={isConnecting}
        >
          {getButtonTextForHubConnection(isConnected, isConnecting)}
        </Button>
      </Card.Footer>
    </Card>
  );
};

export default ControlsSection;
